import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-lg modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  class: "alert alert-danger text-dark",
  role: "alert"
}
const _hoisted_11 = { class: "modal-footer" }

import { computed, toRef } from 'vue'

    import FormDependenciesList from '@Alternatives/Forms/Components/FormDependenciesList.vue'

    import type { FormDefDependenciesReadModel } from '@Alternatives/Forms/Domain/readmodels'
    import type { FormDeleterDialogViewModel } from '@Alternatives/Forms/Components/FormDeleterDialog'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'FormDeleterDialog',
  props: {
    viewModel: {}
  },
  emits: ["delete-form"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- computed ----------------

    const opened = computed(() => vm.value?.opened ?? false)

    const initialized = computed(() => vm.value.initialized)
    const name = computed(() => vm.value.name)
    const deps = computed<FormDefDependenciesReadModel | null>(() => vm.value.deps)

    const hasDependants = computed<boolean | null>(() => deps.value?.HasDependants ?? null)
    const dependantsCount = computed<number | null>(() => deps.value?.Count ?? null)

    const canDelete = computed(() => initialized.value && hasDependants.value === false)

    // ---------------- actions ----------------

    function handleDelete()
    {
        emit('delete-form', vm.value.id)
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: _normalizeClass(["modal-header", {'bg-danger': canDelete.value}])
              }, [
                _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "modal-title" }, "Delete form", -1 /* CACHED */)),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: close
                }, "×")
              ], 2 /* CLASS */),
              _createElementVNode("div", _hoisted_5, [
                (!initialized.value)
                  ? (_openBlock(), _createElementBlock("h4", _hoisted_6, [...(_cache[1] || (_cache[1] = [
                      _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                      _createTextVNode(" Checking dependencies... ", -1 /* CACHED */)
                    ]))]))
                  : _createCommentVNode("v-if", true),
                (initialized.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      (canDelete.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _cache[4] || (_cache[4] = _createElementVNode("h4", null, "Are you sure you want to delete this form?", -1 /* CACHED */)),
                            _createElementVNode("p", null, [
                              _cache[2] || (_cache[2] = _createTextVNode("You are about to delete '", -1 /* CACHED */)),
                              _createElementVNode("strong", null, _toDisplayString(name.value), 1 /* TEXT */),
                              _cache[3] || (_cache[3] = _createTextVNode("'. This can't be undone.", -1 /* CACHED */))
                            ])
                          ]))
                        : _createCommentVNode("v-if", true),
                      (!canDelete.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                              _cache[8] || (_cache[8] = _createElementVNode("h5", { class: "alert-heading" }, "Cannot delete this form", -1 /* CACHED */)),
                              _createElementVNode("p", null, [
                                _cache[5] || (_cache[5] = _createTextVNode(" The form '", -1 /* CACHED */)),
                                _createElementVNode("strong", null, _toDisplayString(name.value), 1 /* TEXT */),
                                _cache[6] || (_cache[6] = _createTextVNode("' is used in ", -1 /* CACHED */)),
                                _createElementVNode("strong", null, _toDisplayString(dependantsCount.value), 1 /* TEXT */),
                                _cache[7] || (_cache[7] = _createTextVNode(" places. To delete this form, first remove it from where it is used. ", -1 /* CACHED */))
                              ])
                            ]),
                            _createVNode(FormDependenciesList, { readModel: deps.value }, null, 8 /* PROPS */, ["readModel"])
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_11, [
                (canDelete.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-danger",
                      onClick: handleDelete
                    }, "Delete"))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-secondary",
                  onClick: close
                }, "Cancel")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})